import DataManagement from "components/DataManagement";
import DataConsumption from "components/DataConsumption";
import DataIngestion from "components/DataIngestion";
import Settings from "components/Common/Settings";

export const CLIENT_ROUTES = {
  data_ingestion: {
    component: DataIngestion,
    path: "/ingestion/*",
  },
  data_management: {
    component: DataManagement,
    path: "/management/*",
  },
  data_consumption: {
    component: DataConsumption,
    path: "/consumption/*",
  },
};

export const SETTINGS_ROUTES = {
  settings: {
    component: Settings,
    path: "/settings/*",
  },
};
